import images from "../../assets/images/assets";
import { useParams } from "react-router-dom";
import { useContext, useState } from "react";
import { ShopContext } from "../Context/ShopContext";

// FrontEnd - Dummy Data
// import { productsData } from "../../assets/data/data";

const ProductDataSection = () => {
  const [size, setSize] = useState("");
  const { id } = useParams();
  const { products, currency, addToCart } = useContext(ShopContext);

  // console.log("Received ID from URL:", id);
  // console.log("Type of ID:", typeof id);
  // console.log("All products:", products);

  const product = products.find((product) => {
    // console.log("Comparing:", {
    //   productId: product._id,
    //   productIdType: typeof product._id,
    //   urlId: id,
    //   urlIdType: typeof id,
    // });
    return product._id === id;
  });

  // console.log("Found product:", product);

  const [imageOrder, setImageOrder] = useState([0, 1, 2]);

  if (!product) {
    return (
      <h1 className="text-3xl mt-20 text-center text-rose-500">
        Product Not Found!
      </h1>
    );
  }

  const swapImages = (clickedIndex) => {
    setImageOrder(([main, side1, side2]) => {
      if (clickedIndex === side1) {
        return [side1, main, side2];
      } else if (clickedIndex === side2) {
        return [side2, side1, main];
      }
      return [main, side1, side2];
    });
  };

  return (
    <div className="flex gap-12 md:gap-6 lg:gap-8 flex-col lg:flex-row lg:items-center lg:pl-28">
      {/* Product Images Section */}
      <div className="flex-1 md:px-8 lg:px-0 flex md:flex-col-reverse lg:flex-row flex-col-reverse items-center gap-4 sm:flex-row z-[99]">
        {/* Side Images */}
        <div className="side centered-row lg:flex-col lg:h-[450px] lg:w-[175px] w-full h-[380px] md:h-[180px] md:gap-4 lg:gap-11.25">
          <div
            style={{ backgroundImage: `url(${product.images[imageOrder[1]]})` }}
            className="w-full h-full bg-zinc-50 border border-prime-red lg:rounded-t-full rounded-b-md cursor-pointer bg-cover bg-center saturate-50 hover:saturate-150 transition2"
            onClick={() => swapImages(imageOrder[1])}
          ></div>

          <div
            style={{ backgroundImage: `url(${product.images[imageOrder[2]]})` }}
            className="hidden md:block w-full h-full border border-prime-red bg-zinc-50 rounded-md cursor-pointer bg-cover bg-center saturate-50 hover:saturate-150 transition2"
            onClick={() => swapImages(imageOrder[2])}
          ></div>
        </div>

        {/* Main Image */}
        <div
          style={{ backgroundImage: `url(${product.images[imageOrder[0]]})` }}
          className="main bg-lime-100 w-full h-[450px] md:h-[600px] border border-prime-red cursor-pointer rounded-t-full rounded-b-lg bg-cover bg-center saturate-150"
        ></div>
      </div>

      {/* Product Info */}
      <div className="flex-1 md:px-8 lg:px-0">
        <h1 className="font-bold italic text-2xl md:text-3xl lg:text-4xl mt-2 playfair-display">
          {product.name}
        </h1>
        {/* Product Rating */}
        <div className="flex items-center gap-1 mt-2">
          <img src={images.star_icon} alt="star" className="w-3.5" />
          <img src={images.star_icon} alt="star" className="w-3.5" />
          <img src={images.star_icon} alt="star" className="w-3.5" />
          <img src={images.star_icon} alt="star" className="w-3.5" />
          <img src={images.star_dull} alt="star" className="w-3.5" />
          <p className="pl-2">(122)</p>
        </div>

        {/* Product Price */}
        <p className="mt-5 text-3xl font-medium">
          {currency} {product.price}
        </p>

        {/* Product Description */}
        <p className="mt-5 text-gray-500 md:w-4/5">
          {product.name} dolor sit amet consectetur, adipisicing elit. Corrupti
          corporis, perferendis voluptas quidem voluptatem vero esse nemo labore
          nulla quis, hic, similique sapiente aperiam.
        </p>

        {/* Product Sizes */}
        <div className="flex flex-col gap-4 my-8">
          <p>Select Package</p>

          <div className="flex gap-2">
            {product.sizes.map((item, index) => (
              <button
                onClick={() => setSize(item)}
                className={`border py-2 px-4 bg-gray-100 ${
                  item === size ? "border-orange-500" : ""
                }`}
                key={index}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <button
          onClick={() => addToCart(product._id)}
          className="bg-black cursor-pointer text-white px-8 py-3 text-sm active:bg-gray-700 hover:bg-transparent hover:text-zinc-900 border border-zinc-900 transition2"
        >
          ADD TO CART
        </button>

        <hr className="mt-8 sm:w-4/5" />

        <div className="text-sm text-gray-500 mt-5 flex flex-col gap-1">
          <p>100% Original product</p>
          <p>Cash on delivery is available on 7 days</p>
          <p>Easy return and exchange policy within 7 days.</p>
        </div>
      </div>
    </div>
  );
};

export default ProductDataSection;
